module.exports = __webpack_public_path__ + "img/alicante_alacant.39c9e66f.jpg";